import React from 'react';
import Reveal from './Reveal';

/**
 * Trust / partner / certification logo bar.
 *
 * TO ADD LOGOS:
 *   1. Put the image files in  frontend/public/partners/  (transparent PNG or SVG,
 *      roughly even visual height works best).
 *   2. Add an entry below: { name, src, url? }  — src is "/partners/<file>".
 * Leave the array empty to hide the whole bar (renders nothing).
 */
const logos = [
  // { name: 'Maersk',   src: '/partners/maersk.svg',   url: 'https://www.maersk.com' },
  // { name: 'DHL',      src: '/partners/dhl.png' },
  // { name: 'ISO 9001', src: '/partners/iso-9001.png' },
];

const TrustBar = ({ heading = 'Trusted by partners worldwide' }) => {
  if (!logos.length) return null;

  return (
    <section className="py-14 bg-white border-y border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          {heading && (
            <p className="text-sm font-medium uppercase tracking-wider text-gray-500 mb-8">
              {heading}
            </p>
          )}
          <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-8">
            {logos.map((logo, i) => {
              const img = (
                <img
                  src={logo.src}
                  alt={logo.name}
                  loading="lazy"
                  className="h-10 md:h-12 w-auto object-contain opacity-70 grayscale transition-all duration-300 hover:opacity-100 hover:grayscale-0"
                />
              );
              return (
                <Reveal as="span" key={i} delay={i * 80} className="inline-flex">
                  {logo.url ? (
                    <a href={logo.url} target="_blank" rel="noopener noreferrer" title={logo.name} className="inline-flex">
                      {img}
                    </a>
                  ) : (
                    <span title={logo.name} className="inline-flex">{img}</span>
                  )}
                </Reveal>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default TrustBar;
